<template>
    <div class="sustainable-component competence-matrix-multiskills">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-matrix-multiskills</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" label="Anställd" :items="employees" v-model="selectedEmployeeId" item-title="CompleteName" item-value="EmployeeId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="addEmpty(internalModel.JobPositions)" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" label="Befattning (mångkunnighet)" :items="addEmpty(filterItems(internalModel.JobPositions))" v-model="selectedMultiskillPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-1">BlockNr.</th>
                                <th class="col-4">BlockNamn</th>
                                <th class="col-2">Godkänd</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in multiskills" :key="index">
                                <td>
                                    {{item.BlockNumber}}
                                </td>
                                <td>
                                    {{item.BlockName}}
                                </td>
                                <td>
                                    <span v-if="item.NrOfPassed > 0"><a href="javascript:void(0)" @click="printMultiskills(item.BlockId)">{{item.NrOfPassed}}</a></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CompetenceService from "../../Services/CompetenceService";
    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {

        name: 'competence-matrix-multiskills',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async loadEmployees() {
                this.loading++;
                try {
                    var tmp = [];
                    tmp = await WageService.getEmployeesFromCompany("Fornamn");
                    tmp.splice(0, 0, { EmployeeId: "0", CompleteName: "Alla individer" });
                    this.employees = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            addEmpty(positions) {
                var tmpArray = [];
                tmpArray = JSON.parse(JSON.stringify(positions))
                tmpArray.splice(0, 0, { JobPositionId: "0", Name: "Alla positioner" });
                return tmpArray;
            },
            filterItems(positions) {
                var tmpArray = [];
                for (var i = 0; i < positions.length; i++) {
                    if (positions[i].JobPositionId != this.selectedPosition) {
                        tmpArray.push(positions[i]);
                    }
                }
                return tmpArray;
            },
            async loadMatrix() {
                this.loading++;
                try {
                    this.multiskills = await CompetenceService.getMultiskillMatrix(this.selectedMultiskillPosition, this.selectedEmployeeId, this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printMultiskills(jobPositionBlockId) {
                var selectedPosition = JSON.parse(JSON.stringify(this.selectedPosition));
                if (selectedPosition == null)
                    selectedPosition = "0";
                var selectedEmployeeId = JSON.parse(JSON.stringify(this.selectedEmployeeId));
                if (selectedEmployeeId == null)
                    selectedEmployeeId = "0";
                this.newWindow = window.open('/competenceprint/PrintMultiskills?jobPositionBlockId=' + jobPositionBlockId + "&jobPositionId=" + selectedPosition + "&employeeId=" + selectedEmployeeId, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                selectedEmployeeId: null,
                selectedMultiskillPosition: null,
                selectedPosition: null,
                employees: [],
                multiskills:[],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                
            };
        },
        watch: {
            selectedEmployeeId: function () {
                if (this.selectedEmployeeId != null)
                    this.loadMatrix();
            },
            selectedMultiskillPosition: function () {
                this.loadMatrix();
            },
            selectedPosition: function (newVal) {
                this.$emit('positionSelected', newVal)
                this.loadMatrix();
            },

        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            this.loadEmployees();
            
            //if (this.internalModel.JobPositions.length > 0) {
            //    this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            //}
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
